import {
    Component, OnInit, ViewChild, Output, EventEmitter,
    DoCheck, KeyValueDiffers, KeyValueDiffer, KeyValueChanges, KeyValueChangeRecord, OnDestroy
} from '@angular/core';
import {NgModel} from '@angular/forms';
import {Observable, Subject, Subscription} from 'rxjs';
import {BDModalComponent} from '@brother-apps/brother-dealerapp-shared-lib';

import FormUtils from '../../utils/formUtils';

import {UserContextService} from '../../../core/services/user-context.service';
import {CredentialsManager} from '../../../core/services/credentils.manager';
import {ISafeCredential} from '../../../core/interfaces/safe-credential.interface';
import {ICredential} from '../../../core/interfaces/credential.interface';
import {ICredentialPostRequest} from '../../../core/interfaces/credential-post-request.interface';
import {ICredentialPutRequest} from '../../../core/interfaces/credential-put-request.interface';
import {ToastService} from '../../services/toast.service';
import {AppConstants} from '../../../core/app-constants';

@Component({
    selector: 'app-credentials-modal',
    templateUrl: './credentials-modal.component.html',
    styleUrls: ['./credentials-modal.component.scss']
})

export class CredentialsModalComponent implements OnInit, OnDestroy, DoCheck {

    @ViewChild('htmlInsideModal', {static: true}) htmlInsideModal: BDModalComponent;
    @ViewChild('loginITScope', {static: true}) loginITScope: NgModel;
    @ViewChild('securityITScope', {static: true}) securityITScope: NgModel;
    @ViewChild('loginCadooz', {static: true}) loginCadooz: NgModel;
    @ViewChild('securityCadooz', {static: true}) securityCadooz: NgModel;
    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

    public readonly EMAIL_PATTERN: RegExp = AppConstants.EMAIL_PATTERN;

    private differ: KeyValueDiffer<string, any>;
    private modalObservable: Observable<void>;
    private modalSubject: Subject<void>;
    private credentialsSubscription: Subscription;

    model: any = {
        itscope: {
            login: '',
            security: '',
        },
        cadooz: {
            login: '',
            security: '',
        }
    };
    isSecondTabActive: boolean = false;
    public hasWsError = false;

    constructor(
        private differs: KeyValueDiffers,
        private userContextService: UserContextService,
        private credentialsManager: CredentialsManager,
        private toastService: ToastService,
    ) {
        this.differ = this.differs.find({}).create();
        this.modalSubject = new Subject<void>();
        this.modalObservable = this.modalSubject.asObservable();

        this.loadCredentialsToModel();
        this.credentialsSubscription = this.credentialsManager.getCredentialsObservable().subscribe(() => {
            this.loadCredentialsToModel();
        });
    }

    ngOnInit() {
        console.log('BDCredentialsModalComponent init');
    }

    ngOnDestroy() {
        console.log('BDCredentialsModalComponent destroy');
        if (this.credentialsSubscription) {
            this.credentialsSubscription.unsubscribe();
        }
    }

    ngDoCheck() {
        const change: KeyValueChanges<string, any> | null = this.differ.diff(this.htmlInsideModal);
        if (change) {
            change.forEachChangedItem((record: KeyValueChangeRecord<string, any>) => {
                if ((record.key === 'isActive') && (record.currentValue === false)) {
                    // console.log('close');
                    // save empty IT-Scope credentials
                    if (!this.credentialsManager.hasCredentials()) {
                        this.createEmptyITScopeCredential();
                    }
                    this.modalSubject.next();
                    this.onClose.emit();
                }
            });
        }
    }

    getCredentialFromModel(provider: string): ICredential {
        if (this.model[provider]) {
            return {
                provider,
                login: this.model[provider].login,
                security: this.model[provider].security,
            } as ICredential;
        }
        return null;
    }

    async createOrUpdateCredential(provider: string): Promise<void> {

        if (this.model[provider].login && this.model[provider].security) {


            const userId = this.userContextService.getUserId();
            const credential: ISafeCredential = this.credentialsManager.getCredential(provider);
            const modelCredential: ICredential = this.getCredentialFromModel(provider);

            if (provider === CredentialsManager.PROVIDER_ITSCOPE) {
                const apiKey = await this.credentialsManager.getITScopeAPIKey(modelCredential.login, modelCredential.security);
                if (!credential) {
                    // create new credential because credential are not loaded via login ws
                    await this.credentialsManager.createItScopeCredential(userId, apiKey);
                } else {
                    await this.credentialsManager.updateItScopeCredentials(userId, apiKey);
                }
            } else {
                if (!credential) {
                    // create new credential because credential are not loaded via login ws

                    const body: ICredentialPostRequest = {
                        credentials: [modelCredential]
                    };
                    await this.credentialsManager.createCredentials(userId, body);
                } else {
                    // update credential
                    const body: ICredentialPutRequest = {
                        login: modelCredential.login,
                        security: modelCredential.security
                    };
                    await this.credentialsManager.updateCredential(userId, provider, body);
                }
            }
        }
    }


    async createEmptyITScopeCredential(): Promise<void> {
        try {
            const userId = this.userContextService.getUserId();
            const itscopeCredential: ICredential = {
                provider: CredentialsManager.PROVIDER_ITSCOPE,
            } as ICredential;
            const body: ICredentialPostRequest = {
                credentials: [itscopeCredential]
            };
            await this.credentialsManager.createCredentials(userId, body);
        } catch (error) {

        }
    }

    loadCredentialsToModel(): void {
        this.loadCredentialToModel(CredentialsManager.PROVIDER_ITSCOPE);
        this.loadCredentialToModel(CredentialsManager.PROVIDER_CADOOZ);
    }

    loadCredentialToModel(provider: string): void {
        let credential: ISafeCredential = this.credentialsManager.getCredential(provider);
        if (credential === null) {
            credential = {provider: provider} as ISafeCredential;
        }
        this.model[provider].login = credential.login || '';
        this.model[provider].security = credential.login ? '********' : '';
    }

    hasITScopeCredential(): boolean {
        return this.credentialsManager.hasITScopeCredentialSecuritySet();
    }

    /*
    hasCadoozCredential(): boolean {
        return this.credentialsManager.hasCredential(CredentialsManager.PROVIDER_CADOOZ, true);
    }
    */

    open(): Observable<void> {
        this.htmlInsideModal.open();
        return this.modalObservable;
    }

    close(): void {
        this.htmlInsideModal.close();
    }

    togglePasswordVisibility(event): void {
        const target = event.currentTarget;
        if (target.previousSibling.type === 'password') {
            target.previousSibling.type = 'text';
        } else {
            target.previousSibling.type = 'password';
        }
        target.classList.toggle('is-visible');
    }

    async saveITScope(): Promise<void> {
        try {
            await this.createOrUpdateCredential(CredentialsManager.PROVIDER_ITSCOPE);
            this.toastService.showSuccessWide('Ihr Zugang wurde erfolgreich hinterlegt.');
            this.resetValidation(this.loginITScope);
            this.resetValidation(this.securityITScope);
            // await this.userContext.reloadUserDetails();
            this.close();
        } catch (error) {
            console.error(error);
            this.hasWsError = true;
        }
    }

    skipITScope(): void {
        // this.isSecondTabActive = true;
        this.close();
    }

    /*
    async saveCadooz(): Promise<void> {
        try {
            await this.createOrUpdateCredential(CredentialsManager.PROVIDER_CADOOZ);
            this.toastService.showSuccessWide('Ihr Zugang wurde erfolgreich hinterlegt.');
            this.resetValidation(this.loginCadooz);
            this.resetValidation(this.securityCadooz);
            // this.isSecondTabActive = false;
            this.close();
        } catch (error) {
            console.log(error);
        }
    }

    skipCadooz(): void {
        // this.isSecondTabActive = false;
        this.close();
    }
    */

    hasSuccess(input: NgModel): boolean {
        return FormUtils.hasSuccess(input);
    }

    hasError(input: NgModel): boolean {
        return FormUtils.hasError(input);
    }

    resetValidation(input: NgModel): void {
        FormUtils.resetValidation(input.control);
    }

}
